// Cliente de API + sessão (token JWT em memória/sessionStorage)
const TOKEN_KEY = 'opticaos.token';
const USER_KEY = 'opticaos.usuario';

export const sessao = {
  get token() { return sessionStorage.getItem(TOKEN_KEY); },
  get usuario() {
    try { return JSON.parse(sessionStorage.getItem(USER_KEY)); } catch { return null; }
  },
  entrar(token, usuario) {
    sessionStorage.setItem(TOKEN_KEY, token);
    sessionStorage.setItem(USER_KEY, JSON.stringify(usuario));
  },
  sair() {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
  },
};

export async function api(caminho, { method = 'GET', body, form } = {}) {
  const headers = {};
  if (sessao.token) headers.Authorization = `Bearer ${sessao.token}`;
  if (body) headers['Content-Type'] = 'application/json';

  const res = await fetch(`/api${caminho}`, {
    method, headers,
    body: form ? form : body ? JSON.stringify(body) : undefined,
  });

  if (res.status === 401 && caminho !== '/auth/login') {
    sessao.sair();
    window.location.href = '/login';
    throw new Error('Sessão expirada');
  }

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    if (res.status === 413) throw new Error('Foto(s) muito grande(s) — máximo 25MB por foto. Tire outra ou reduza.');
    throw new Error(data.erro || `Erro na requisição (${res.status})`);
  }
  return data;
}

// ---------- constantes compartilhadas ----------
export const FLUXO = ['digitada', 'recebido', 'pedido_feito', 'lente_recebida', 'montagem', 'servico_pronto', 'enviado_loja', 'recebido_loja'];
export const ST_LABEL = {
  digitada: 'Digitada', recebido: 'Recebido', pedido_feito: 'Pedido Feito',
  lente_recebida: 'Lente Recebida', montagem: 'Montagem', servico_pronto: 'Serviço Pronto',
  enviado_loja: 'Enviado p/ Loja', recebido_loja: 'Recebido na Loja',
  perda_montagem: 'Perda na montagem', cancelada: 'Cancelada', reativada: 'Reativada',
};
export const ST_COR = {
  digitada: '#d64545', recebido: '#e8590c', pedido_feito: '#e6a817',
  lente_recebida: '#c9b90b', montagem: '#a3b31c', servico_pronto: '#8ab821',
  enviado_loja: '#4caf50', recebido_loja: '#1e7d46',
  perda_montagem: '#b91c1c', cancelada: '#6b7280', reativada: '#6c8ea3',
};

const range = (de, ate, passo) => {
  const a = [];
  for (let v = de; v <= ate + 1e-9; v += passo) a.push(v.toFixed(2));
  return a;
};
export const ESFERICOS = ['', ...range(0.25, 22, 0.25).map(v => '+' + v).reverse(), '0.00', ...range(0.25, 22, 0.25).map(v => '-' + v)];
export const CILINDRICOS = ['', ...range(0.25, 10, 0.25).map(v => '-' + v)];
export const ADICOES = ['', ...range(0.75, 3.5, 0.25).map(v => '+' + v)];

export const fmtData = d => new Date(d).toLocaleString('pt-BR', {
  day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit',
});
